import { useTranslation } from 'react-i18next';

import useDeleteRoleAccess from 'Domain/role/useDeleteRoleAccess';
import { useModal } from 'Store/modal';

const useOpenDeleteModal = () => {
  const { t } = useTranslation('role');
  const { onOpenModal } = useModal();

  const { mutate: onDeleteRoleAccess } = useDeleteRoleAccess();

  const onOpenDeleteModal = (id) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('deleteModalTitle'),
      contentDescription: t('deleteModalDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('deleteModalSubmitButton'),
      secondaryButtonText: t('deleteModalCancelButton'),
      onClickPrimaryButton: () => {
        onDeleteRoleAccess(id);
      },
    });
  };

  return { onOpenDeleteModal };
};

export default useOpenDeleteModal;